import { createSlice } from '@reduxjs/toolkit'
import { IEntityState } from './entity.interfaces'
const initialState: IEntityState = {
  entity: {
    entity: []
  }
}

const entitySlice = createSlice({
  name: 'entity',
  initialState,
  reducers: {
    setEntity(state, action) {
      state.entity.entity = action.payload
    }
  }
})

export const { setEntity } = entitySlice.actions

export default entitySlice.reducer
